import {RouteConfig} from "vue-router";
import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import {ifAuthenticated} from "@/routes/access";
import PartnerUsers from "@/pages/Pages/UserManagement/PartnerUsers.vue";
import PartnerUser from "@/pages/Pages/UserManagement/PartnerUser.vue";
import CallCenterUsers from "@/pages/Pages/UserManagement/CallCenterUsers.vue";
import CallCenterUser from "@/pages/Pages/UserManagement/CallCenterUser.vue";
import UserRoles from "@/pages/Pages/UserManagement/UserRoles.vue";
import UserRole from '@/pages/Pages/UserManagement/UserRole.vue';
import PartnerUserRoles from "@/pages/Pages/UserManagement/PartnerUserRoles.vue";
import PartnerUserRole from '@/pages/Pages/UserManagement/PartnerUserRole.vue';
import SystemUsers from "@/pages/Pages/UserManagement/SystemUsers.vue";
import SystemUser from "@/pages/Pages/UserManagement/SystemUser.vue";
import ModerationTemplates from "@/pages/Pages/UserManagement/ModerationTemplates.vue";
import ModerationTemplate from "@/pages/Pages/UserManagement/ModerationTemplate.vue";
import ModerationDistributions from "@/pages/Pages/UserManagement/ModerationDistributions.vue";
import ModerationDistribution from "@/pages/Pages/UserManagement/ModerationDistribution.vue";
import SystemActions from "@/pages/Pages/UserManagement/SystemActions.vue";
import SystemAction from "@/pages/Pages/UserManagement/SystemAction.vue";
import ActionUsers from "@/pages/Pages/UserManagement/ActionUsers.vue";
import ActionUser from "@/pages/Pages/UserManagement/ActionUser.vue";


const userManagementMenu: RouteConfig = {
  path: "/user_management",
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  redirect: "/user_management/partner_users",
  name: "User management",
  children: [
    {
      path: "partner_users",
      name: "partner_users",
      components: {default: PartnerUsers},
      meta: {
        icon: "supervisor_account",
        msgKey: 'menu.item.user.manage.user.partners'
      },
    },
    {
      path: "partner_users/new",
      name: "partner_users_new",
      components: {default: PartnerUser},
      meta: {
        icon: "supervisor_account",
        parentPath: "/user_management/partner_users",
        msgKey: 'menu.item.user.manage.user.partners'
      },
    },
    {
      path: "partner_users/:id",
      name: "partner_users_edit",
      components: {default: PartnerUser},
      meta: {
        icon: "supervisor_account",
        parentPath: "/user_management/partner_users",
        msgKey: 'menu.item.user.manage.user.partners'
      },
    },
    {
      path: "callcenter_users",
      name: "callcenter_users",
      components: {default: CallCenterUsers},
      meta: {
        icon: "supervisor_account",
        msgKey: 'menu.item.user.manage.user.cc'
      },
    },
    {
      path: "callcenter_users/new",
      name: "callcenter_users_new",
      components: {default: CallCenterUser},
      meta: {
        icon: "supervisor_account",
        parentPath: "/user_management/callcenter_users",
        msgKey: 'menu.item.user.manage.user.cc'
      },
    },
    {
      path: "callcenter_users/:id",
      name: "callcenter_users_edit",
      components: {default: CallCenterUser},
      meta: {
        icon: "supervisor_account",
        parentPath: "/user_management/callcenter_users",
        msgKey: 'menu.item.user.manage.user.cc'
      },
    },
    {
      path: "user_roles",
      name: "user_roles",
      components: {default: UserRoles},
      meta: {
        icon: "supervisor_account",
        msgKey: 'menu.item.user.manage.user.role'
      },
    },
    {
      path: "user_roles/new",
      name: "user_roles_new",
      components: {default: UserRole},
      meta: {
        icon: "supervisor_account",
        parentPath: "/user_management/user_roles",
        msgKey: 'menu.item.user.manage.user.role'
      },
    },
    {
      path: "user_roles/:id",
      name: "user_roles_edit",
      components: {default: UserRole},
      meta: {
        icon: "supervisor_account",
        parentPath: "/user_management/user_roles",
        msgKey: 'menu.item.user.manage.user.role'
      },
    },
    {
      path: "partner_user_roles",
      name: "partner_user_roles",
      components: {default: PartnerUserRoles},
      meta: {
        icon: "supervisor_account",
        msgKey: 'menu.item.user.manage.user.partners.role'
      },
    },
    {
      path: "partner_user_roles/new",
      name: "partner_user_roles_new",
      components: {default: PartnerUserRole},
      meta: {
        icon: "supervisor_account",
        parentPath: "/user_management/partner_user_roles",
        msgKey: 'menu.item.user.manage.user.partners.role'
      },
    },
    {
      path: "partner_user_roles/:id",
      name: "partner_user_roles_edit",
      components: {default: PartnerUserRole},
      meta: {
        icon: "supervisor_account",
        parentPath: "/user_management/partner_user_roles",
        msgKey: 'menu.item.user.manage.user.partners.role'
      },
    },
    {
      path: "system_users",
      name: "system_users",
      components: {default: SystemUsers},
      meta: {
        icon: "supervisor_account",
        msgKey: 'menu.item.user.manage.user.system'
      },
    },
    {
      path: "system_users/new",
      name: "system_users_new",
      components: {default: SystemUser},
      meta: {
        icon: "supervisor_account",
        parentPath: "/user_management/system_users",
        msgKey: 'menu.item.user.manage.user.system'
      },
    },
    {
      path: "system_users/:id",
      name: "system_users_edit",
      components: {default: SystemUser},
      meta: {
        icon: "supervisor_account",
        parentPath: "/user_management/system_users",
        msgKey: 'menu.item.user.manage.user.system'
      },
    },
    {
      path: "templates_moderation",
      name: "templates_moderation",
      components: {default: ModerationTemplates},
      meta: {
        icon: "supervisor_account",
        msgKey: 'menu.item.user.manage.template.moderation'
      },
    },
    {
      path: "templates_moderation/:channel/:id",
      name: "templates_moderation_edit",
      components: {default: ModerationTemplate},
      meta: {
        icon: "supervisor_account",
        parentPath: "/user_management/templates_moderation",
        msgKey: 'menu.item.user.manage.template.moderation'
      },
    },
    {
      path: "distributions_moderation",
      name: "distributions_moderation",
      components: {default: ModerationDistributions},
      meta: {
        icon: "supervisor_account",
        msgKey: 'menu.item.user.manage.distr',
      },
    },
    {
      path: "distributions_moderation/:channel/:id",
      name: "distributions_moderation_edit",
      components: {default: ModerationDistribution},
      meta: {
        icon: "supervisor_account",
        parentPath: "/user_management/distributions_moderation",
        msgKey: 'menu.item.user.manage.distr',
      }
    },
    {
      path: "system_actions",
      name: "system_actions",
      components: {default: SystemActions},
      meta: {
        icon: "supervisor_account",
        msgKey: 'menu.item.user.manage.system.actions'
      }
    },
    {
      path: "system_actions/:id",
      name: "system_actions_edit",
      components: {default: SystemAction},
      meta: {
        icon: "supervisor_account",
        parentPath: "/user_management/system_actions",
        msgKey: 'menu.item.user.manage.system.actions'
      },
    },
    {
      path: "action_users",
      name: "action_users",
      components: {default: ActionUsers},
      meta: {
        icon: "supervisor_account",
        msgKey: 'menu.item.user.manage.user.logs'
      },
    },
    {
      path: "action_users/:id",
      name: "action_users_info",
      components: {default: ActionUser},
      meta: {
        icon: "supervisor_account",
        parentPath: "/user_management/action_users",
        msgKey: 'menu.item.user.manage.user.logs'
      },
    },
  ],
};

export default userManagementMenu;
